// Mirrors backend/reply_templates.py — keep the wording in sync.
const SIGNOFF = ["", "Best regards,", "The Lake Monitor AI team", "lakemonitor.ai"];
export const MAX_NOTE_LEN = 1500;

const firstName = (lead) => (lead.name || "").trim().split(/\s+/)[0] || "there";
const waterbody = (lead) => (lead.waterbody_type || "waterbody").toLowerCase();
const size = (lead) => (lead.surface_acres ? ` (~${lead.surface_acres} acres)` : "");

export const REPLY_TEMPLATES = [
  {
    id: "quote-sent",
    label: "Quote sent",
    status: "Proposal Sent",
    subject: (lead) => `Your Lake Monitor AI quote — ${lead.reference}`,
    lines: (lead) => [
      `Hi ${firstName(lead)},`,
      "",
      `Thank you for your interest in mapping your ${waterbody(lead)} in ${lead.region}${size(lead)}. Attached is our proposal covering scope, deliverables, schedule and pricing.`,
      "",
      "A few highlights:",
      "• Full-coverage sonar survey with bathymetric contours, vegetation and bottom-hardness layers",
      "• GIS-ready deliverables (shapefiles/GeoTIFF/PDF) plus a summary report",
      "• Typical turnaround of 2–3 weeks after the field day",
      "",
      "The quote is valid for 30 days. Happy to walk through it on a quick call — just reply with a time that works for you.",
    ],
  },
  {
    id: "need-info",
    label: "Need more info",
    status: "Contacted",
    subject: (lead) => `A few questions about your ${waterbody(lead)} survey — ${lead.reference}`,
    lines: (lead) => [
      `Hi ${firstName(lead)},`,
      "",
      `Thanks for reaching out about your ${waterbody(lead)} in ${lead.region}. To put together an accurate quote, could you help with a few details?`,
      "",
      lead.surface_acres
        ? `1. Approximate surface area (you mentioned ~${lead.surface_acres} acres — is that current?)`
        : "1. Approximate surface area in acres",
      "2. Is there a boat ramp or shoreline access we can launch from?",
      "3. Your main goal (depth/volume, vegetation, sediment, habitat, dredging planning)?",
      "4. Preferred timing or any deadlines (e.g. before treatment or a board meeting)?",
      "",
      "A pin on a map or a link to the location is also very helpful. Once we have this we'll send a proposal within 2 business days.",
    ],
  },
  {
    id: "scheduling",
    label: "Scheduling",
    status: "Contacted",
    subject: (lead) => `Scheduling your survey — ${lead.reference}`,
    lines: (lead) => [
      `Hi ${firstName(lead)},`,
      "",
      `Great news — we're ready to schedule the field survey for your ${waterbody(lead)} in ${lead.region}.`,
      "",
      "We have availability in the coming weeks; please share two or three dates that work for you. On survey day we'll need:",
      "• Access to a launch point (ramp or shoreline)",
      "• A site contact's phone number in case we need to reach someone",
      "• Any gate codes or permission notes for private property",
      "",
      "Surveys run rain or shine except in high winds or lightning; if we need to reschedule for weather we'll let you know the day before.",
    ],
  },
];

export const renderReply = (template, lead, note = "") => {
  const extra = note.trim() ? ["", ...note.trim().split("\n")] : [];
  return { subject: template.subject(lead), body: [...template.lines(lead), ...extra, ...SIGNOFF].join("\n") };
};

export const buildMailto = (lead, subject, body) =>
  `mailto:${encodeURIComponent(lead.email)}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
